import { Environment } from '@carsys/enums/environment'
import * as types from './types'
export const toggleSidebar = () => ({
  type: types.TOGGLE_SIDEBAR
})

export const hideSidebar = () => ({
  type: types.SIDEBAR_VISIBLE,
  payload: {
    value: false
  }
})

export const enableIframeTopMenu = () => ({
  type: types.IFRAME_TOP_MENU,
  payload: {
    value: true
  }
})

export const setSimulatedEnvironment = (value: Environment) => ({
  type: types.SIMULATED_ENVIROMENT,
  payload: {
    value
  }
})
